module.exports = __webpack_public_path__ + "img/lexile-table.fa684841.png";